/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The account constraint the algos run on: the sell mandate (capped on a withdrawal run) and the cash budget.
 * @export
 * @interface AccountConstraint
 */
export interface AccountConstraint {
    /**
     * 
     * @type {number}
     * @memberof AccountConstraint
     */
    targetGrowthSleeve?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountConstraint
     */
    minSellConstraint?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountConstraint
     */
    maxBuyConstraint?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AccountConstraint
     */
    isCappedAtMinSell?: boolean;
}

/**
 * Check if a given object implements the AccountConstraint interface.
 */
export function instanceOfAccountConstraint(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccountConstraintFromJSON(json: any): AccountConstraint {
    return AccountConstraintFromJSONTyped(json, false);
}

export function AccountConstraintFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountConstraint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetGrowthSleeve': !exists(json, 'target_growth_sleeve') ? undefined : json['target_growth_sleeve'],
        'minSellConstraint': !exists(json, 'min_sell_constraint') ? undefined : json['min_sell_constraint'],
        'maxBuyConstraint': !exists(json, 'max_buy_constraint') ? undefined : json['max_buy_constraint'],
        'isCappedAtMinSell': !exists(json, 'is_capped_at_min_sell') ? undefined : json['is_capped_at_min_sell'],
    };
}

export function AccountConstraintToJSON(value?: AccountConstraint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_growth_sleeve': value.targetGrowthSleeve,
        'min_sell_constraint': value.minSellConstraint,
        'max_buy_constraint': value.maxBuyConstraint,
        'is_capped_at_min_sell': value.isCappedAtMinSell,
    };
}

